import React from 'react';
import { EntityTaskDetails } from 'components/common/tasks/entityTaskDetails';

export const OrderTaskDetails = () => {
  return <EntityTaskDetails entityName={'BRAND'} />;
};
